export default "__VITE_ASSET__B$Ooo4Iz__"